/**
 * loại yêu cầu thuê bao
 */
export default {
  IsBuyNew: 0, //' Bán mới
  IsUpgrade: 1, // Nâng cấp
  IsExtended: 2, // Gia hạn
  IsFree: 3, // Miễn phí
  IsTrial: 4, // Dùng thử
  Different: 5, // Loại khác
  ChangeInfo: 6, //Thay đổi thông tin
  BuyMore: 7, // Mua thêm
  ExtendedAndBuyMore: 8, //Vừa gia hạn vừa mua thêm
  ChangeLicenseType: 9, // Thay đổi loại GPSD (hiện tại đang dùng cho SME2022)
};
